import React from "react";
import styles from '../MapG.module.css'
import DisplacementSphere from "../components/background/DisplacementSphere";
import {ThemeToggle} from "../components/theme/ThemeToggle";
import {Today} from "../components/content/Today";
// import LG from "../assets/lg.png"

const PageNotFound = () => {
    return <>
        <DisplacementSphere/>
        <div className={styles.lg} style={{textAlign: "center"}}>
            {/*<img src={LG} height="150px"/>*/}
        </div>
        <Today/>
        <ThemeToggle/>
    </>;
};
export default PageNotFound
